<template>
  <div class="navbar-container d-flex content align-items-center">
    <!-- Nav Menu Toggler -->
    <ul class="nav navbar-nav d-xl-none">
      <li class="nav-item">
        <b-link
          class="nav-link"
          @click="toggleVerticalMenuActive"
        >
          <feather-icon
            icon="MenuIcon"
            size="21"
          />
        </b-link>
      </li>
    </ul>

    <!-- Left Col -->
    <div
      class="bookmark-wrapper align-items-center flex-grow-1 d-none d-lg-flex"
    >
      <dark-Toggler class="d-none d-lg-block" />
      <span
        class="system-version"
        @click="openModalVersao"
      >
        {{ code }}
      </span>
    </div>

    <!-- Modal Notas de Versão -->
    <b-modal
      id="modalVersao"
      v-model="modalVisible"
      title="Notas da Versão"
      centered
      size="lg"
    >
      <div class="table-responsive">
        <table class="table table-striped text-center">
          <thead>
            <tr>
              <th>Título</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td>
                <pre style="font-size: 14px">{{ summary }}</pre>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
      <template #modal-footer>
        <b-button
          variant="secondary"
          @click="closeModalVersao"
        >Fechar</b-button>
      </template>
    </b-modal>

    <b-navbar-nav class="nav align-items-center ml-auto">
      <b-nav-item-dropdown
        right
        toggle-class="d-flex align-items-center dropdown-user-link"
        class="dropdown-user"
      >
        <template #button-content>
          <div class="d-sm-flex d-none user-nav">
            <p class="user-name font-weight-bolder mb-0">
              {{ user.name }}
            </p>
          </div>
          <b-avatar
            size="40"
            variant="light-primary"
            badge
            :src="user.photo_url"
            class="badge-minimal"
            badge-variant="success"
          />
        </template>

        <b-dropdown-item
          :to="{ name: 'Profile'}"
          link-class="d-flex align-items-center"
        >
          <feather-icon
            size="16"
            icon="UserIcon"
            class="mr-50"
          />
          <span>Meu Perfil</span>
        </b-dropdown-item>

        <!-- <b-dropdown-item link-class="d-flex align-items-center">
          <feather-icon size="16" icon="MailIcon" class="mr-50" />
          <span>Inbox</span>
        </b-dropdown-item>

        <b-dropdown-item link-class="d-flex align-items-center">
          <feather-icon size="16" icon="CheckSquareIcon" class="mr-50" />
          <span>Task</span>
        </b-dropdown-item>

        <b-dropdown-item link-class="d-flex align-items-center">
          <feather-icon size="16" icon="MessageSquareIcon" class="mr-50" />
          <span>Chat</span>
        </b-dropdown-item> -->

        <b-dropdown-divider />

        <b-dropdown-item
          link-class="d-flex align-items-center"
          @click="logout"
        >
          <feather-icon
            size="16"
            icon="LogOutIcon"
            class="mr-50"
          />
          <span>Sair</span>
        </b-dropdown-item>
      </b-nav-item-dropdown>
    </b-navbar-nav>
  </div>
</template>

<script>
import {
  BLink,
  BNavbarNav,
  BNavItemDropdown,
  BDropdownItem,
  BDropdownDivider,
  BAvatar,
  BModal,
  BButton,
} from 'bootstrap-vue'
import DarkToggler from '@core/layouts/components/app-navbar/components/DarkToggler.vue'
import Cookies from 'js-cookie'

export default {
  components: {
    BLink,
    BNavbarNav,
    BNavItemDropdown,
    BDropdownItem,
    BDropdownDivider,
    BAvatar,
    BModal,
    BButton,
    DarkToggler,
  },
  props: {
    toggleVerticalMenuActive: {
      type: Function,
      default: () => {},
    },
  },
  data() {
    return {
      authenticated: false,
      disabled: true,
      user: {},
      empresa: [],
      versoes: null,
      code: '',
      summary: '',
      modalVisible: false,
    }
  },
  mounted() {
    const self = this
    self.getVersoes()
    setTimeout(() => {
      self.user = self.$store.state.user
      if (self.user.password_expired == 1) {
        $('#modalChangePassword').modal({
          backdrop: 'static',
          keyboard: false,
        })
      }
    }, 100)
    this.versaoUpdateInterval = setInterval(() => {
      this.updateVersaoCookie()
    }, 3600000)
  },
  beforeDestroy() {
    clearInterval(this.versaoUpdateInterval)
  },
  methods: {
    openModalVersao() {
      this.$bvModal.show('modalVersao')
    },
    closeModalVersao() {
      this.$bvModal.hide('modalVersao')
    },
    async getVersoes() {
      const api = `${this.$store.state.api}versoes/`

      try {
        const response = await axios.get(api)

        if (!response || !response.data) {
          console.error('Resposta da API inválida:', response)
          return
        }

        const versoes = response.data.data
        const versao = versoes[versoes.length - 1]

        const newVersao = versao.code

        const savedVersao = Cookies.get('current_versao')
        if (savedVersao && savedVersao !== newVersao) {
          alert(
            'Uma nova versão está disponível. Por favor, atualize o sistema.',
          )
        }

        if (savedVersao !== newVersao) {
          this.saveVersaoInCookie(newVersao)
        }

        this.versoes = versao
        this.code = versao.code
        this.summary = versao.summary
      } catch (error) {
        console.error('Erro ao obter versões:', error)
        if (error.response && error.response.data) {
          this.$message(null, error.response.data, 'error')
        }
      }
    },
    saveVersaoInCookie(versaoCode) {
      Cookies.set('current_versao', versaoCode, { expires: 7, path: '/' })
    },
    checkVersao() {
      const savedVersao = Cookies.get('current_versao')
      if (savedVersao && savedVersao !== this.versoes.code) {
        alert(
          'Uma nova versão está disponível. Por favor, atualize o navegador.',
        )
      }
    },
    updateVersaoCookie() {
      this.getVersoes()
    },
    logout() {
      const self = this
      const api = `${this.$store.state.api}logout`

      axios
        .post(api)
        .then(response => {
          localStorage.removeItem('token')

          self.$router.push({ path: '/login' })
        })
        .catch(error => {
          this.errors = error.response.data.errors
          this.$message('Erro', 'Erro ao realizar logout', 'error')
        })
    },
  },
}
</script>
